Namespace 'Monitoring.Views.Dashboards.Modes'

class Monitoring.Views.Dashboards.Modes.AssistantExplorerView extends Backbone.View

  template: JST["backbone/templates/monitoring/dashboards/modes/assistant/index"]

  switchmodeEventByModeId: {
    text: 'showTextMode',
    visual: 'showVisualMode',
    domain: 'showDomainMode'
  }

  initialize: ({ searchQuery, submodesPermissions }) ->
    @searchQuery = searchQuery
    @vueAssistantExplorerComponent = new VueInBackbone.VueApp('assistant-explorer',
      {
        searchQuery: searchQuery.toJSON(),
        show: false,
        permissions: submodesPermissions
      }
    )
    @vueAssistantExplorerComponent.on('change-mode', @changeMode)
    @vueAssistantExplorerComponent.on('save-assistant', @saveAssistant)

  render: ->
    @$el.html(@template)
    @$el.find('.assistant-explorer-section').append(@vueAssistantExplorerComponent.el)
    @vueAssistantExplorerComponent.render()
    @

  show: ->
    @vueAssistantExplorerComponent.update({ show: true })

  update: (searchQuery) ->
    @searchQuery = searchQuery
    @vueAssistantExplorerComponent.update({ searchQuery: searchQuery.toJSON() })

  changeMode: (modeId) =>
    @trigger(@switchmodeEventByModeId[modeId])

  saveAssistant: (id) =>
    @searchQuery.changeState('assistant_explorer_id', id)

  destroy: ->
    @remove()

  remove: ->
    @vueAssistantExplorerComponent.remove()
    super()
